export enum TradeStatusEnum {
  Aberto = "Aberto",
  Rejeitado = "Rejeitado",
  Aprovado = "Aprovado",
  Pendencia = "Pendencia",
  ExpiradoSLA = "ExpiredSLA",
  Pendente = "Pendente"
}

export const getStatusesList = () => Object.keys(TradeStatusEnum);


// WEBPACK FOOTER //
// ./src/services/enum/TradeStatusEnum.ts